module.exports = __webpack_public_path__ + "c810fb1e81981ca125bbe59a5dd306b4.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/fontello/fontello-webfont.woff
 ** module id = ./src/styles/fonts/fontello/fontello-webfont.woff
 ** module chunks = 0
 **/